import React from 'react'
import type { ImageProps } from 'next/image'
import Image from 'next/image'

export type ContentfulImageWithPlaceholderProps = {
  width: number
  height: number
  src: string
  alt: string
} & ImageProps

export function ContentfulImageWithPlaceholder(
  props: ContentfulImageWithPlaceholderProps,
) {
  const { width, height, src, alt, fill } = props
  const isNotUsingDimensions = fill === true
  const placeholderWidth = Math.ceil(width / 100)
  const placeholderHeight = Math.ceil(height / 100)
  const placeholderUrl = new URL(src)
  placeholderUrl.search = `?w=${placeholderWidth.toString()}&h=${placeholderHeight.toString()}&fit=fill`
  if (isNotUsingDimensions) {
    const propsWithoutWidthAndHeight: Omit<
      ContentfulImageWithPlaceholderProps,
      'width' | 'height'
    > & {
      width?: number
      height?: number
    } = {
      ...props,
    }
    delete propsWithoutWidthAndHeight.width
    delete propsWithoutWidthAndHeight.height
    return (
      <Image
        {...propsWithoutWidthAndHeight}
        sizes="100vw"
        alt={alt}
        src={src}
        blurDataURL={placeholderUrl.href}
        placeholder="blur"
      />
    )
  }
  return (
    <Image
      {...props}
      alt={alt}
      src={src}
      height={height}
      width={width}
      blurDataURL={placeholderUrl.href}
      placeholder="blur"
      className="h-auto max-w-full"
    />
  )
}
